import React from 'react';
import 'twin.macro';
import { DividerTitle } from '../divider';

export const SettingsDividerTitle = ({ ...restProps }) => (
  <DividerTitle tw='mt-6 first-of-type:mt-0' {...restProps} />
);
